import moment from 'moment';
import { ValueDataType, SortDirection } from 'src/app/services/api.services';

export function isDateLikeDataType(dataType: ValueDataType) {
  return dataType == ValueDataType.DateOnly
    || dataType == ValueDataType.DateTime
    || dataType == ValueDataType.TimeOnly;
}

export function isNumericDataType(dataType: ValueDataType) {
  return dataType == ValueDataType.Decimal
    || dataType == ValueDataType.Number
    || dataType == ValueDataType.Integer;
}

export function isDataTypeCompatible(dataType: ValueDataType, dataType2: ValueDataType) {
  return dataType == dataType2
    || (isNumericDataType(dataType) && isNumericDataType(dataType2))
    || (isDateLikeDataType(dataType) && isDateLikeDataType(dataType2));
}

export function dataTypeCanBeAssigned(dataType: ValueDataType, targetDataType: ValueDataType) {
  if (isDataTypeCompatible(dataType, targetDataType)) {
    return true;
  }

  return false;
}

export interface DataTypeInfo {
  icon: string;
  title: string;
};

export function getDataTypeInfo(dataType: ValueDataType): DataTypeInfo {
    switch (dataType) {
      case ValueDataType.Text:
        return { icon: 'fas fa-text', title: 'Text' };

      case ValueDataType.Decimal:
        return { icon: 'fas fa-dollar-sign', title: 'Currency' };

      case ValueDataType.Number:
        return { icon: 'far fa-plus', title: 'Number' };

      case ValueDataType.Integer:
        return { icon: 'far fa-plus', title: 'Integer' };

      case ValueDataType.Boolean:
        return { icon: 'fas fa-adjust', title: 'Boolean' };

      case ValueDataType.DateOnly:
        return { icon: 'far fa-calendar', title: 'Date' };

      case ValueDataType.DateTime:
        return { icon: 'far fa-calendar', title: 'Date and Time' };

      case ValueDataType.TimeOnly:
        return { icon: 'far fa-clock', title: 'Time' };
    }

    return { icon: 'far fa-question-circle', title: 'Unknown' };
}

export interface TimeValue {
  hour: number;
  minute: number;
  second: number;
  hourPart: string;
  minutePart: string;
  secondPart: string;
  text: string;
};

export function parseTimeValue(value: any, seconds: boolean): TimeValue {
  let time: moment.Duration;

  if (!value) {
    time = moment.duration('00:00:00');
  }
  else if (moment.isMoment(value) || moment.utc(value).isValid()) {
    time = moment.duration(moment.utc(value).format(seconds ? 'HH:mm:ss' : 'HH:mm'));
  }
  else 
  if (!moment.isDuration(value)) {
    time = moment.duration(value);
  }

  let result: any = {
    hour: time.hours(),
    minute: time.minutes(),
    second: time.seconds(),
  };

  result = {
    ...result,
    hourPart: padTimePart(result.hour),
    minutePart: padTimePart(result.minute),
    secondPart: padTimePart(result.second),
  };

  let text = `${result.hourPart}:${result.minutePart}`;

  if (seconds)
    text += `:${result.secondPart}`;

  result = {
    ...result,
    text
  };

  return result;
}

export function padTimePart(v: number) {
  let text = '' + v;

  if (text.length == 1)
    text = '0' + text;

  return text;
}

export function getDataTypeSortIconName(dataType: ValueDataType, direction: SortDirection) {
  if (isNumericDataType(dataType)) {
    if (direction == SortDirection.Descending)
      return `fa-sort-amount-down`;
    else
      return `fa-sort-amount-down-alt`;
  }
  else {
    if (direction == SortDirection.Descending)
      return `fa-sort-alpha-down-alt`;
    else
      return `fa-sort-alpha-down`;
  }
}
